<script>
  export let title = "Heading";
  export let dot = "blue";
</script>

<style>
  .heading-container {
    display: flex;
    align-items: center;
  }
  .heading-container h2 {
    margin: 0;
    padding: 0;
    flex: 1;
  }

  .dot {
    width: 20px;
    height: 20px;
    background-color: var(--blue);
    display: block;
    margin-right: 10px;
    border-radius: 50%;
  }

  .dot-blue {
    background-color: var(--blue);
  }
  .dot-yellow {
    background-color: var(--yellow);
  }
  .dot-green {
    background-color: var(--green);
  }
</style>

<div class="heading-container">
  <span class="dot dot-{dot}" />
  <h2 class="heading">{title}</h2>
</div>
